/**
 * @module Core Web Vitals
 * @description Core Web Vitals Reporting
 */
const thresholds = {
    CLS: [0.1, 0.25],
    FCP: [1800, 3000],
    FID: [100, 300],
    LCP: [2500, 4000],
    TTFB: [800, 1800],
    INP: [200, 500], // Adding INP thresholds based on web.dev recommendations
  };
  
  /**
   * @function getRating
   * @description Get Core Web Vitals rating for each metric.
   * @see https://github.com/GoogleChromeLabs/web-vitals-report/blob/71b0879334798c732f460945ded5267cab5a36bf/src/js/analytics.js#L57-L65
   *
   * @param  {Number}  value
   * @param  {Array}   thresholds
   * @return {String}
   */
  const getRating = (value, threshold) => {
    if (value > threshold[1]) return 'POOR';
    if (value > threshold[0]) return 'NI'; // NI == Needs Improvement
    return 'GOOD';
  };
  
  /**
   * @function sendToAnalytics
   * @see https://github.com/GoogleChrome/web-vitals#readme
   *
   *
   * @param  {Object}  metric { name, value }
   * @return {void}
   */
  const sendToAnalytics = (metric) => {
    const { name, value } = metric;
    
    // Track web vitals using Segment
    analytics.track('Web Vitals', {
      metricName: String(name),
      rating: getRating(value, thresholds[name]),
      value: Number(value),
      url: window.location.href,
      path: window.location.pathname
    });
  };
  
  export { thresholds, getRating };
  export default sendToAnalytics;